import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Box, Typography, CircularProgress } from "@mui/material";
import { withRouter } from "../../../providers/withRouter";
import { UsuarioContext } from "../../../providers/userContext";
import { DataTable, ProgressBarWithColors } from "../../../components";
import { BsSearch } from "react-icons/bs";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import { editarAAFF, getAAFFs, getTecnico, visitTec } from "../../../services";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { formatoFechas, formatoFechasEs } from "../../../functions/funciones";
import Lupa from "../../../icons/lupa.svg";
import { ImCross } from "react-icons/im";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useRecogerURLParamsFiltros,
  construirURLParamsFiltros,
} from "./../../../functions/parametrosURL/funcionesParamsURL";

const AAFFTecnico = (props) => {
  const { t } = useTranslation('common');
  const user = useContext(UsuarioContext);
  const [recargar, setRecargar] = useState(0);
  //   const { loading, data, setPagination, pagination, fetchData } = useAAFFs();
  const [loading, setLoading] = useState(true);
  const { filtrosIniciales, filtroOrder } = useRecogerURLParamsFiltros();
  const [busqueda, setBusqueda] = useState(filtrosIniciales);
  const [desde, setDesde] = useState(undefined);
  const [hasta, setHasta] = useState(undefined);
  const [tecnico, setTecnico] = useState({});
  const [msjFincas, setMsjFincas] = useState("");
  const [cargandoVisitas, setCargandoVisitas] = useState(false);
  const [busquedaActiva, setBusquedaActiva] = useState(false);
  const [clearFilterActivo, setClearFilterActivo] = useState(false);
  const [data, setData] = useState({
    meta: {},
    rows: [],
  });
  useEffect(() => {
    // fetchData();
    setRecargar(false);
  }, [recargar]);

  const navigate = useNavigate();
  const location = useLocation();

  const clearFilters = () => {
    setDesde(undefined);
    setHasta(undefined);
    setBusqueda({});
    setClearFilterActivo(true);
  };

  const fetchData = async ({
    offset,
    limit,
    filtros = busqueda,
    order,
    orderBy,
  } = {}) => {
    delete filtros.tech_id;

    construirURLParamsFiltros(
      navigate,
      offset || 1,
      limit || 50,
      filtros,
      order,
      orderBy
    );

    orderBy = orderBy || filtroOrder.ordenadoPor || "id";
    order = order || filtroOrder.orden || "ASC";

    try {
      setLoading(true);
      const responseTecnico = await getTecnico(props.params.nif);
      const payload = {
        filtros: { ...filtros, tech_id: responseTecnico.id },
        params: { page: offset, limit, order, orderBy },
      };
      const response = await getAAFFs(payload);
      setTecnico(responseTecnico);
      const { meta, data } = response;
      setData({
        meta,
        rows: formatData(data),
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const cambiarFechaEncargo = (nif) => {
    Swal.fire({
      title: t('technicians.dateDialog.changeOrderDate'),
      html: `<input type="date" id="fecha" class="swal2-input">`,
      confirmButtonText: t('technicians.dateDialog.change'),
      focusConfirm: false,
      preConfirm: () => {
        const fecha = Swal.getPopup().querySelector("#fecha").value;
        if (!fecha) {
          Swal.showValidationMessage(t('technicians.dateDialog.insertDate'));
        }
        return { fecha: fecha };
      },
    }).then((result) => {
      let data = {
        nif: nif,
        // fechaEncargo: formatoFechas(result.value.fecha),
      };
      editarAAFF(data)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) {
            toast.success(t('technicians.messages.editedSuccess'));
            setRecargar(!recargar);
          } else {
            let mensajes = [];

            res.data.error.map((err) => {
              mensajes = err;
              console.log(err.message);
              toast.error(t('technicians.messages.editError'));
            });
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(t('technicians.messages.editError'));
        });
    });
  };
  const AAFFRows = [
    {
      id: "razonSocial",
      numeric: false,
      disablePadding: false,
      label: t('technicians.columns.administrator'),
      overrideFunc: (data, row) => (
        <Link
          to={"/tecnicos/" + row.paramNif + "/aaff/" + row.nif + "/comunidades"}
        >
          {data}
        </Link>
      ),
    },
    // {
    //   id: "fechaEncargo",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "FECHA ENCARGO",
    //   overrideFunc: (data, row) => (
    //     <Typography onClick={() => cambiarFechaEncargo(row.nif)} style={{ textAlign: 'left' }}>
    //       {data ? formatoFechasEs(data) : "-"}
    //     </Typography>
    //   ),
    // },
    {
      id: "nif",
      numeric: false,
      disablePadding: false,
      label: t('technicians.columns.nif'),
      overrideFunc: (data, row) => row.parent_id ? "" : data
    },
    // {
    //   id: "localizacion",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "LOCALIZACIÓN",
    // },
    {
      id: "municipio",
      numeric: false,
      disablePadding: false,
      label: t('technicians.columns.municipality'),
    },
    {
      id: "provincia",
      numeric: false,
      disablePadding: false,
      label: t('technicians.columns.province'),
    },
    // {
    //   id: "numeroComunidades",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "Nº COMUNIDADES",
    //   overrideFunc: (data) => (
    //     <Typography style={{ textAlign: 'left' }}>
    //       {data}
    //     </Typography>
    //   ),
    // },
    {
      id: "comunidadesVisitadas",
      numeric: false,
      disablePadding: false,
      label: t('technicians.columns.visitedCommunities'),
      noObjeto: true,
      overrideFunc: (data, row) => (
        <ProgressBarWithColors
          value={data}
          label={
            <Typography>
              {row.visitadasCount} / {row.pendientesCount + row.visitadasCount}
            </Typography>
          }
        />
      ),
    },
    {
      id: "comunidadesRenovasVisitadas",
      numeric: false,
      disablePadding: false,
      label: t('technicians.columns.renewedVisitedCommunities'),
      noObjeto: true,
      overrideFunc: (data, row) => (
        <ProgressBarWithColors
          value={data}
          label={
            <Typography>
              {row.renovadasVisitadasCount} /{" "}
              {row.renovadasCount + row.renovadasVisitadasCount}
            </Typography>
          }
        />
      ),
    },
    {
      id: "hojaVisita",
      numeric: false,
      disablePadding: false,
      label: t('technicians.columns.visitSheets'),
      noObjeto: true,
      overrideFunc: (data, row) => (
        <Link
          to={
            "/tecnicos/" + row.paramNif + "/aaff/" + row.nif + "/hojas-visita"
          }
        >
          <img src={Lupa} alt={t('technicians.columns.visitSheets')} className="tableIcon" />
        </Link>
      ),
    },
  ];

  const formatData = (data) => {
    return data.map((row) => {
      const comunidadesActivas =
        row.properties?.filter((objeto) => objeto.status === true) ?? [];
      return {
        razonSocial: row.razonSocial || row.propertie?.aaff?.nombreContacto,
        // fechaEncargo: row.fechaEncargo || '',
        nif: row.nif,
        parent_id: row.parent_id,
        id: row.id,
        localizacion: row.municipio + "-" + row.provincia,
        municipio: row.municipio,
        provincia: row.provincia,
        numeroComunidades: comunidadesActivas.length,
        comunidades: comunidadesActivas,
        pendientesCount: row.pendientesCount,
        visitadasCount: row.visitadasCount,
        renovadasCount: row.renovadasCount,
        renovadasVisitadasCount: row.renovadasVisitadasCount,
        comunidadesVisitadas:
          (row.visitadasCount /
            (row.pendientesCount + (row.visitadasCount || 1))) *
            100 ?? 0,
        comunidadesRenovasVisitadas:
          (row.renovadasVisitadasCount /
            (row.renovadasCount + (row.renovadasVisitadasCount || 1))) *
            100 ?? 0,
        hojaVisita: row,
        paramNif: props.params.nif,
      };
    });
  };
  const filtrarFechas = async () => {
    let d = desde;
    let h = hasta;
    let msjFincas = "";
    setCargandoVisitas(true);
    if (h < d || d === "Invalid Date" || h === "Invalid Date") {
      msjFincas = t('technicians.messages.incorrectDates');
      setMsjFincas(msjFincas);
      setCargandoVisitas(false);
    } else {
      let data = {
        tech_id: tecnico.id,
        desde: d,
        hasta: h,
      };
      const resp = await visitTec(data);

      const numFincasVisitadas = resp.filter((item) =>[1, 6].includes(item.detailsCae?.sales?.servp_id)).length;
      const numFincasVisitadasRenovadas = resp.filter((item) => [3, 7].includes(item.detailsCae?.sales?.servp_id)).length;

      if (numFincasVisitadas === 0 && numFincasVisitadasRenovadas === 0) {
        msjFincas = t('technicians.messages.noVisitsInPeriod');
      } else {
        msjFincas = t('technicians.messages.visitsInPeriod', { newVisits: numFincasVisitadas, renewalVisits: numFincasVisitadasRenovadas });
      }
      setMsjFincas(msjFincas);
      setCargandoVisitas(false);
    }
  };
  
  return (
    <>
      <BreadCrumb
        rutas={[
          { path: "/tecnicos", label: t('technicians.title') },
          {
            path: "/tecnicos",
            label: `${tecnico.nombre + " " + tecnico.apellidos}`,
          },
        ]}
        style={{ margin: "0 10px" }}
      />
      <div className="pageContent tableContainer">
        <div className="tableWrapper">
          <div className="buscador">
            <input
              type="date"
              placeholder={t('filters.from')}
              value={desde || ""}
              onChange={(event) => setDesde(event.currentTarget.value)}
            />
            <input
              type="date"
              placeholder={t('filters.to')}
              value={hasta || ""}
              onChange={(event) => setHasta(event.currentTarget.value)}
            />
            <button className="btn-buscador" onClick={() => clearFilters()}>
              <ImCross />
            </button>
            <button onClick={() => filtrarFechas()}>
              <BsSearch />
            </button>
            <div>
              {cargandoVisitas ? (
                <CircularProgress
                  style={{
                    color: "#92004D",
                    height: "20px",
                    width: "20px",
                    padding: "0",
                  }}
                />
              ) : (
                <p>{msjFincas}</p>
              )}
            </div>
          </div>
          <Box className="pageContent">
            <Box sx={{ mb: 10 }}>
              <DataTable
                data={data.rows}
                isLoading={loading}
                headers={AAFFRows}
                fetcher={fetchData}
                currentPage={data.current_page}
                meta={data.meta}
                totalItems={data.total}
                totalPages={data.totalPages}
                nextPage={data.next_page}
                filtros={busqueda}
                busquedaActiva={busquedaActiva}
                setBusquedaActiva={setBusquedaActiva}
                clearFilterActivo={clearFilterActivo}
                setClearFilterActivo={setClearFilterActivo}
                mensaje={t('technicians.messages.noPropertyManagers')}
                enumerate={true}
              />
            </Box>
          </Box>
        </div>
      </div>
    </>
  );
};

export default withRouter(AAFFTecnico);
